import type { FiscalPeriod } from "../Financials/types";

export const fiscalPeriod: FiscalPeriod = "QTR";

export const componentClassNames =
	"min-w-[300px] max-w-[350px] flex-1 border-none bg-background";

export const gradientClassName =
	"bg-gradient-to-b from-bg-background from-[20%] to-[110%]";
export const greenGradientClassName = `${gradientClassName} to-success-light`;
export const redGradientClassName = `${gradientClassName} to-error-light`;
export const grayGradientClassName = `${gradientClassName} to-light-gray`;

export const quoteFields: string[] = [
	"ticker",
	"distance_to_xd_high",
	"max_dd_xy",
	"roe",
	"roic",
	"debttoequity",
	"dividend_yield",
	"tp_est",
	"tp_cnt_est_rev_up",
	"analyst_recommendation",
	"market_cap",
	"rt_price",
	"rt_price_chg.d1",
	"fcffgrowth",
	"next_rpt_date",
	"code",
	"sector_spdr_code",
	"name",
	"sector",
	"inc_country",
	"stock_exchange",
	"short_description",
	"one_month_score",
	"three_months_score",
	"six_months_score",
	"one_year_score",
	"price_to_exponential_moving_average",
	"pe_ttm_ratio",
	"pe_fy_ratio",
	"pe_next_fy_ratio",
	"peg_ttm",
	"adj_close_pct_chg",
	"adj_close_price_xd.0_D",
	"em_score",
	"trend_indicator_final_status",
	"powerday_trend_status",
	"volatility_strength_status",
	"seq_outperforming_days_spy",
	"composite_score",
	"act_rpt_date",
	"sales_surprise",
	"eps_amt_diff_surp",
	"sales_acceleration_curr_and_1_q_back",
	"profitmargin",
	"rs_pct_chg_nasdaq",
	"rs_abs_chg_nasdaq",
	"seq_outperforming_days_sector",
	"drift_name",
	"eps_growth.street_q_to_4q_back",
	"eps_growth.street_curr_y_to_1_y_back",
	"combined_sequential_positive_acc.street",
	"combined_acceleration_curr_and_1_q_back.street",
	"sales_growth.sales_q_to_4q_back",
	"sales_growth.sales_curr_y_to_1_y_back",
	"sales_sequential_positive_acc",
	"profit_margin_change_curr_and_4_q_back",
	"free_cash_flow_change_curr_and_4_q_back",
	"freecashflow",
	"relative_strength_index",
	"pe_ftm_ratio",
	"peg_ftm",
	"rss_abs_chg_nasdaq.ed",
	"price_momentum_signal",
	"composite_10d_slope",
	"cross_moving_average.ema20.ema50",
];
